module.exports = __webpack_public_path__ + "img/selected2-min.c31c110c.png";